var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"five"}},[_c('img',{attrs:{"src":require("../../assect/500.jpg")}}),_c('div',{staticClass:"advance",on:{"click":_vm.advance}},[_c('img',{attrs:{"src":require("../../assect/rocket.png"),"alt":""}}),_c('p',[_vm._v("回到首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }